import { PropertyValueMap } from 'lit';

export interface ChangedPropsInterface extends PropertyValueMap<any> {
  [key: string]: unknown;
}